<script lang="ts">
    import {navigateTo, routeIsActive} from "svelte-router-spa";

    export let to:string = '';
    export let currentRoute = {};

    let classApplication:string = 'text-gray-500';
    $: if (currentRoute && to && routeIsActive(to, false)) {
        classApplication = 'text-blue-600 bg-gray-100';
    } else {
        classApplication = 'text-gray-500';
    }
</script>

<a on:click={() => navigateTo(to)} class="flex flex-col items-center text-sm py-2 hover:bg-gray-100 {classApplication}">
    <slot name="icon">Icon</slot>
    <slot></slot>
</a>